// src/components/dash/components/main/components/reports/components/EnhancedHeader/index.js

import React from "react";
import { LuFilter } from "react-icons/lu";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { MdOutlineBugReport } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import { IoMdDownload, IoMdClose } from "react-icons/io";
import { FaFilePdf } from "react-icons/fa";
import {
  HeaderContainer,
  SearchSection,
  FilterSection,
  FilterInfo,
} from "./styles";

const EnhancedHeader = ({
  localSearchTerm,
  handleSearchChange,
  handleKeyDown,
  handleSearchSubmit,
  toggleFilter,
  handleOpenTool,
  filters,
  isLoading,
  totalDocuments,
  onClearFilters,
  handleDownloadKeys,
  handleDownloadPDF,
}) => {
  const formatDate = (dateObj) => {
    if (!dateObj?.year) return null;
    const months = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ];
    return `${String(dateObj.day).padStart(2, "0")} ${months[dateObj.month]} ${
      dateObj.year
    }`;
  };

  return (
    <HeaderContainer>
      <SearchSection>
        <div className="tools">
          <button
            className="filter-btn"
            data-tooltip="Filtrar"
            onClick={toggleFilter}
          >
            <LuFilter />
            <span>Filtro Relatório</span>
          </button>

          <button
            className="filter-btn"
            data-tooltip="Download XML"
            onClick={() => handleOpenTool("download_xml")}
          >
            <AiOutlineCloudDownload />
            <span>Download XMLs</span>
          </button>

          <button
            className="filter-btn"
            data-tooltip="Revisor"
            onClick={() => handleOpenTool("revisor")}
          >
            <MdOutlineBugReport />
            <span>Cruzamento SPEDs</span>
          </button>
        </div>

        <div className="search-input">
          <input
            value={localSearchTerm}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
            placeholder="Buscar por NFe"
          />
          <button className="search-btn" onClick={handleSearchSubmit}>
            <IoSearchOutline />
          </button>
        </div>

        {filters && (
          <div className="actions">
            <span className="total-docs">
              {totalDocuments?.toLocaleString() || 0} docs
            </span>

            <button
              onClick={() => handleDownloadKeys()}
              disabled={isLoading || !filters?.fileId}
              className="action-btn"
              data-tooltip="Download Chaves"
            >
              <IoMdDownload />
              <span>Download TXT</span>
            </button>

            <button
              onClick={() => handleDownloadPDF()}
              disabled={isLoading || !filters?.fileId}
              className="action-btn"
              data-tooltip="Download PDF"
            >
              <FaFilePdf />
              <span>Download PDF</span>
            </button>

            <button
              onClick={onClearFilters}
              disabled={isLoading}
              className="action-btn"
              data-tooltip="Limpar Filtros"
            >
              <IoMdClose />
              <span>Limpar Filtros</span>
            </button>
          </div>
        )}
      </SearchSection>
    </HeaderContainer>
  );
};

export default EnhancedHeader;
